import React, {useState, useRef, useEffect} from 'react'
import './ValidationSreens.scss'
import ValidationOutcomeText from './ValidationOutcomeText'
import {KTSVG} from '../../../_metronic/helpers'
import {apiShowValidationPlaylist} from '../../redux/api'
import {useSearchParams} from 'react-router-dom'

declare global {
  interface Window {
    turnstile?: {
      render: (element: HTMLElement, options: TurnstileOptions) => string
      reset: (widgetId?: string) => void
      remove: (widgetId: string) => void
    }
  }
}

interface TurnstileOptions {
  sitekey: any
  callback?: (token: any) => void
  'expired-callback'?: () => void
  'error-callback'?: () => void
}

const ValidationScreens2 = () => {
  const TURNSTILE_SITE_KEY = process.env.REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY

  const [screen, setScreen] = useState<any>('approved')
  const [turnstileToken, setTurnstileToken] = useState<any>('')
  const [pvin, setPvin] = useState<any>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [response, setResponse] = useState<any>(null)
  const [turnstileReady, setTurnstileReady] = useState<boolean>(false)

  const turnstileRef = useRef<HTMLDivElement>(null)
  const widgetIdRef = useRef<string | null>(null)

  const [searchParams] = useSearchParams()

  const handleQueryParams = () => {
    const vehicleId = searchParams.get('vehicleId')
    const integratorId = searchParams.get('integratorId')

    if (vehicleId) {
      setPvin(vehicleId)
      setScreen('approved')
      return
    }

    if (integratorId) {
      setScreen('integrator')
      return
    }
  }

  useEffect(() => {
    handleQueryParams()
  }, [searchParams])

  useEffect(() => {
    const SCRIPT_ID = 'cloudflare-turnstile-script'

    if (document.getElementById(SCRIPT_ID)) {
      setTurnstileReady(true)
      return
    }

    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
    script.async = true
    script.defer = true
    script.onload = () => setTurnstileReady(true)

    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
      if (window.turnstile) window.turnstile.reset()
    }
  }, [])

  useEffect(() => {
    if (!turnstileReady || !window.turnstile || !turnstileRef.current) return

    turnstileRef.current.innerHTML = ''
    setTurnstileToken('')

    widgetIdRef.current = window.turnstile.render(turnstileRef.current, {
      sitekey: TURNSTILE_SITE_KEY,

      callback: (token: string) => {
        setTurnstileToken(token)
        autoCallShowValidationPlaylistApi(token)
      },

      'expired-callback': () => setTurnstileToken(''),
      'error-callback': () => setTurnstileToken(''),
    })
  }, [turnstileReady])

  const autoCallShowValidationPlaylistApi = (token: string) => {
    if (!pvin || !token) return

    const requestBody = {
      VehicleId: pvin,
      ClientToken: token,
    }

    setIsLoading(true)
    setResponse(null)

    apiShowValidationPlaylist(requestBody)
      .then(({data}) => {
        if (data.Status === 200) {
          setResponse(data)
        } else {
          setResponse(data)
        }
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
        resetToInput()
      })
  }

  const resetToInput = () => {
    setTurnstileToken('')
    setPvin('')
    setIsLoading(false)
    setResponse(null)
    if (window.turnstile && widgetIdRef.current) {
      window.turnstile.reset(widgetIdRef.current)
    }
    handleQueryParams()
  }

  return (
    <div className='container-fluid min-vh-100 d-flex align-items-center justify-content-center validation-screens'>
      <div className='card shadow-lg validation-screens-card'>
        <div className='card-body d-flex flex-column main-container'>
          <div
            className='logo-container border-bottom'
            style={{cursor: 'pointer'}}
            onClick={() => {
              resetToInput()
            }}
            title='Back to start'
          >
            <h3 className='text-danger fw-bold m-0'>DFHV</h3>
          </div>

          {screen === 'approved' && (
            <div
              className='flex-grow-1 d-flex flex-column justify-content-center'
              style={{maxWidth: '390px', width: '100%'}}
            >
              <div className='d-flex flex-column justify-content-center input-screen-container'>
                <span className='d-flex align-items-center justify-content-center flex-column approved-title-container'>
                  <KTSVG
                    path='/media/icons/duotone/General/verify-icon.svg'
                    className='text-success svg-icon-2hx'
                  />
                  <h1 className='approved-title text-center'>Vehicle is approved!</h1>
                </span>
                <div className='approved-pvin-container'>
                  <span className='approved-pvin-text'>{pvin}</span>
                </div>
                <div className='d-flex align-items-center flex-column justify-content-center approved-description-container'>
                  <p className='approved-description-1 text-center'>
                    This taxi is approved by DFHV.
                  </p>
                  <p className='approved-description-2 text-center'>Enjoy your ride!</p>
                </div>
                <span className='d-flex align-items-center justify-content-center'>
                  <div ref={turnstileRef} className='turnstile-container' />
                </span>
                {isLoading && (
                  <div className='text-center mt-3'>
                    <span className='spinner-border spinner-border-sm me-2' />
                    Processing...
                  </div>
                )}
                {response && <ValidationOutcomeText response={response} />}
              </div>
            </div>
          )}

          {screen === 'integrator' && (
            <div className='flex-grow-1 d-flex justify-content-center align-items-center'>
              <h2>Integrator id is not supported yet.</h2>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ValidationScreens2
